import type React from 'react'

interface OnboardingCardProps {
  children: React.ReactNode
  onBack?: () => void
}

export const OnboardingCard: React.FC<OnboardingCardProps> = ({ children, onBack }) => {
  return (
    <div className="relative flex w-full max-w-lg flex-col rounded-2xl bg-white px-8 py-10 shadow-xl">
      {onBack && (
        <button
          onClick={onBack}
          className="absolute left-8 top-6 flex items-center text-sm font-medium text-gray-400 transition-colors hover:text-gray-600"
        >
          <svg className="mr-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Retour
        </button>
      )}
      <div className="mt-6 flex-1">{children}</div>
    </div>
  )
}
